import React from "react";
import { Button, Row, Checkbox, Tooltip } from "antd";

interface ButtonsGroupProps {
    tabControl: string;
    showInactives?: boolean;
    onExport: (type: string, tabControl: string) => void;
    toggleShowInactives?: () => void;
    handleInsert?: () => void;
}

export function ButtonsGroup({
    tabControl,
    showInactives,
    onExport,
    toggleShowInactives,
    handleInsert,
}: ButtonsGroupProps) {
    async function handleExportList(type: string) {
        onExport(type, tabControl);
    }

    function handleShowAll() {
        if (toggleShowInactives) toggleShowInactives();
    }

    return (
        <div>
            <Row>
                <Button
                    onClick={handleInsert}
                    icon="plus"
                    size="default"
                    type="primary"
                    style={{
                        marginBottom: 16,
                        marginLeft: 8,
                        float: "right",
                    }}
                >
                    Inserir
                </Button>
                <Tooltip title="Exportar lista para pdf">
                    <Button
                        onClick={() => handleExportList("pdf")}
                        icon="file-pdf"
                        size="default"
                        style={{
                            marginBottom: 16,
                            marginLeft: 8,
                            float: "right",
                            color: "#fa541c",
                        }}
                    />
                </Tooltip>
                <Tooltip title="Exportar lista para excel">
                    <Button
                        onClick={() => handleExportList("xls")}
                        icon="file-excel"
                        size="default"
                        style={{
                            marginBottom: 16,
                            marginLeft: 8,
                            float: "right",
                            color: "#237804",
                        }}
                    />
                </Tooltip>

                {tabControl !== "CC" && (
                    <Checkbox checked={showInactives} onChange={handleShowAll}>
                        Mostrar todos
                    </Checkbox>
                )}
            </Row>
        </div>
    );
}
